<div class="menu-container px-2 pt-3 flex flex-column justify-content-between">
  <p-panelMenu [model]="items" [style]="{ width: '270px' }" [multiple]="true" />
  <img
    src="./assets/icons/ellada2.png"
    alt="Ellada Logo"
    class="mx-3 w-14rem bg-white py-3"
  />
</div>
